import type ClientItemId from "../schema/ClientItemId";
import type ItemId from "owa-service/lib/contract/ItemId";

// clientItemId has properties that are not in the itemId input object.  graphql will
// complain if an input object has extra properties so flatten this to just itemid
export default function clientItemIdToItemId(srcId: ClientItemId): ItemId {
    const { __type, Id, ChangeKey } = srcId;
    return { __type, Id, ChangeKey };
}
